const setAppointment = (state, appointment) => state.appointment = appointment;
const setAppointments = (state, appointments) => state.appointments = appointments;

let mutations = {
  setAppointment,
  setAppointments,
};

export default mutations;
